import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZRead = z.object({
  readingTime: z.string().nullable(),
  count: z.number().nullable()
})

const ZReadingcimCodeIds = z.object({
  paraMeterId: z.string(),
  paraMeterName: z.string(),
  unit: z.string().nullable(),
  paraMeterReading: z.array(ZRead)
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZReadingcimCodeIds)
})

export type AlertTrendRegisterDataDeviceDashboard = z.infer<typeof ZReadingcimCodeIds>
export type AlertTrendRegisterData = z.infer<typeof ZApiResponse>

export async function getAlertTrendRegisterDataDeviceDashboard (
  startDate: string,
  endDate: string,
  requestParameter: any,
  intervalGroup: string,
  isdefault: boolean,
  timeZone: string,
  onSuccess: (AssetPerformanceLineData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/alertTrend/device?startDate=${startDate}&endDate=${endDate}&intervalGroup=${intervalGroup}&isDefault=${isdefault.toString()}&timeZone=${timeZone}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
